

// export const HOST_API = process.env.REACT_APP_API_URL

export const HOST_API = process.env.REACT_APP_API_URL
